import { lazy } from "react";
import { PageAction } from "../recordDefinition.types";
import { isActiveContact } from "./actions/contactActionHelpers";

// Lazy so opening a rarely-used modal doesn't pull the legacy element library
// into the page bar - statically importing them dragged react-datepicker,
// date-fns and the service layer in behind every page that has a bar.
const ContactStatusModal = lazy(() => import("./actions/ContactStatusModal"));
const ContactAnonymiseModal = lazy(
  () => import("./actions/ContactAnonymiseModal")
);
const ContactMergeModal = lazy(() => import("./actions/ContactMergeModal"));

export const contactPageActions: PageAction[] = [
  {
    id: "set-status",
    label: (record) =>
      isActiveContact(record) ? "Deactivate Contact" : "Activate Contact",
    modal: ContactStatusModal,
  },
  {
    id: "anonymise",
    label: "Anonymise Contact",
    modal: ContactAnonymiseModal,
  },
  {
    id: "merge",
    label: "Merge Contacts",
    modal: ContactMergeModal,
  },
];
